/**
 * Created by anthony on 11/18/14.
 */
var reports = angular.module('reports', [ 'classy', 'authService', 'spreadsheets', 'freeLunchReport', 'reportCreator']);